import {Injectable} from "@angular/core";
import {
    GetSimilarProductsOfProductsUseCase
} from "@app/core/product/application/get-similar-products-of-products.use-case";
import {Product} from "@app/core/product/domain/dtos/product";
import {PopupNotifier} from "@app/presentation/components/errors/popup.notifier";
import {Observable, Subscriber} from "rxjs";
import {take} from "rxjs/operators";
import {createStatusStore} from "@app/presentation/rxjs-utils/create-status-store";
import {onIsLoadingChanges} from "@app/presentation/rxjs-utils/operators/on-is-loading-changes";

@Injectable()
export class NoStockServiceViewModel {

    public notifier = new PopupNotifier();
    private getSimilarProductsSucceedEmitter!: Subscriber<Product[]>;
    public getSimilarProductsSucceed$: Observable<Product[]> = new Observable<Product[]>(emitter => this.getSimilarProductsSucceedEmitter = emitter)

    private similarProductsStatus = createStatusStore();
    isSimilarProductsLoading$ = this.similarProductsStatus.isLoading$;
    constructor(
        private getSimilarProductsOfProductsUseCase: GetSimilarProductsOfProductsUseCase,
    ) { }

    getSimilarProducts(productCodes: string[]) {
        this.getSimilarProductsOfProductsUseCase.execute(productCodes, 10, 1)
            .pipe(
                take(1),
                onIsLoadingChanges(this.similarProductsStatus.setIsLoading),
            )
            .subscribe({
                next: similarProducts => {
                    this.getSimilarProductsSucceedEmitter.next(similarProducts);
                },
                error: error => {
                    this.notifier.notifyError(error);
                }
            })
    }

}
